module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-input user-input-textarea",
    class: _vm.data.class
  }, [(_vm.data.props.defaultValue) ? _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.data.props.defaultValue) + "\n      "), (_vm.data.props.footnotes) ? _c('footnotes', {
    attrs: {
      "all-footnotes": _vm.footnotes,
      "local-footnotes": _vm.data.props.footnotes
    }
  }) : _vm._e()], 1) : _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("- - -\n      "), (_vm.data.props.footnotes) ? _c('footnotes', {
    attrs: {
      "all-footnotes": _vm.footnotes,
      "local-footnotes": _vm.data.props.footnotes
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cea9752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/TEXTAREA.vue
// module id = 707
// module chunks = 0